/* eslint-disable no-nested-ternary */
import { useMemo } from "react";
/**
 * useAutosuggestOptions
 *
 * @description A custom hook that returns a list of options for an autosuggest input.
 * @param {Props<T>} props - The properties for the hook.
 * @param {selected} props.selected - The currently selected item.
 * @param {suggestions} props.suggestions - The list of suggestions to choose from.
 * @returns {T[]} - An array of options for the autosuggest input, ensuring the selected item is always first.
 *
 */
const useAutosuggestOptions = ({ selected, suggestions }) => useMemo(() => {
    // Always include the selected item first
    const base = selected
        ? Array.isArray(selected)
            ? selected
            : [selected]
        : [];
    // Base IDs for filtering
    const baseIds = base.map((item) => item.id);
    // Filter out the selected item from suggestions
    const filtered = suggestions?.filter((item) => !baseIds.includes(item.id)) ?? [];
    // Combine the base and filtered suggestions
    return [...base, ...filtered];
}, [selected, suggestions]);
export default useAutosuggestOptions;
